/***
 * 创建人：
 * 时间：2022-10-11
 * 描述：知识库——实体管理——关系配置——关系创建（单条创建、批量创建）、关系编辑
 * 更新说明:
 */
import {Component,OnInit,Output,EventEmitter,Input,ViewChild,} from "@angular/core";
import { KmsService } from "../../../kms.service";
import { InstanceModuleService } from "../../../serves/instance/instance.module";
import { SwMassageBoxService } from "../../../../../librarys/serves/sw-massage-box.service";
import { SwModalframeComponent } from "../../../../../librarys/components/basic-components/sw-modal-frame/sw-modal-frame.component";
import { SwCreateModalComponentService } from "src/app/librarys/serves/sw-create-modal-component.service";
import { InstanceInfoViewComponent } from "../../../components/instance-info-view/instance-info-view.component";
import { KmsEnum } from "../../../serves/kms-enum";
import { DictionaryService } from "src/app/librarys/serves/public/dictionary.service";
import { SwJwtService } from "src/app/librarys/serves/sw-jwt.service";
import { environment } from "src/environments/environment";
declare let $: any;
@Component({
  selector: 'app-relation-create',
  templateUrl: './relation-create.component.html',
  styleUrls: ['./relation-create.component.css']
})
export class RelationCreateComponent implements OnInit {
  @ViewChild("modal") modal: SwModalframeComponent;
  // 抛出事件
  @Output() callback = new EventEmitter();
  // 组件传参
  @Input() param: any;
  // 新增或编辑操作
  upOrAdd:string = '';
  // 关系创建类型  single:单条创建   batch:批量创建
  state = 'single';
  // 概念模型数据
  ontologyTreeDatas = [];
  // 概念模型树，默认不可选中的父级概念结点
  readonlySelfIds = [];
  // 关系模型树
  relationTreeData = [];
  relationTreeDataCopy = [];

  // 关系模型树，默认不可选中的父级关系结点
  readonlyRetionSelfIds = ["0"];
  // 关系详细数据
  relationDatas = {
    // 起始实体数据信息
    sourceProperties: {
      nodeName: "",
      conceptId: "",
      conceptName: "",
    },
    // 指向实体数据信息
    targetProperties: {
      nodeName: "",
      conceptId: "",
      conceptName: "",
    },
    // 关联关系数据
    properties: {
      startDate: "", // 起始时间
      startDateNote: "", // 起始时间备注
      endDate: "", // 结束时间
      endDateNote: "", // 结束时间备注
      parentId: "", // 关系父级ID
      relationshipId: "", // 关系ID
      relationshipName: "", // 关系名称
      reverseRelationName: "", // 反向关系名称
      relationAlias: "",  // 关系简称 正向
      reverseRelationAlias: "", // 关系简称 反向
      uuid: "", // 当前数据ID
      materialId:'', // 关系来源
      description: "", // 关联备注
      sourceMaterial:'',
      pageNum:null,
      relPageNum:null,
      dataSource: "" 
    },
    sourceUUID: "", // 起始实体ID
    targetUUID: "", // 指向实体ID
  };
  // 实体关系其它内容，时间框验证
  errorList = [];
  // 实体关系其它内容，时间月数据
  monthArr = new Array(12).fill("").map((item, index) => index + 1);
  // 实体关系其它内容，时间天数据
  dayArr = [];
  // 保存按钮是否可用
  clickEnable = true;

  // 实体表格搜索实体名称
  instanceName = "";
  // 实体表格是否显示加载
  isLoading = false;
  // 实体表格内容
  instanceDatas = [];
  // 是否显示右侧实体表格内容
  isShowRightInstance = false;
  // 实体表格选中内容
  selectInstance = [];
  // 实体表格分页组件
  pageBase = {
    current: 1,
    size: 10,
  };
  // 确定的指向实体数据
  rightInstanceDatas = [];
  RelTypeCode = KmsEnum.KGS_RELATION_TYPE;
  // 关系分类树数据
  relTypeOptions:any = [];
  // 选中的关系分类
  relType = '';
  // 是否展示素材列表
  showMaterials = false;
  keyword = '';
  materialList = [];
  // 数据来源是否必填
  isSourceRequired = environment.isSourceRequired;
  materialCategory = "FILE_TYPE_DOCUMENT";
  fileCategoryOptions = [];
  constructor(
    private jwt: SwJwtService,
    private create: SwCreateModalComponentService,
    private kmsService: KmsService,
    private message: SwMassageBoxService,
    private dicService: DictionaryService,
    private instanceModuleService: InstanceModuleService
  ) {}

  ngOnInit() {
    this.fileCategoryOptions = [{ id: "FILE_TYPE_ALL", text: "全部" }];
    this.fileCategoryOptions = this.fileCategoryOptions.concat(
      this.instanceModuleService.getResourceTypeOptions()
    );
    // 获取概念树数据
    this.getConceptTree();
    // 获取关系分类树数据
    this.relTypeOptions = this.dicService.getDictionaryTree(this.RelTypeCode,'dictionaryId','dictionaryName','parentId','dictionaryValue');
    let options = JSON.parse(JSON.stringify(this.relTypeOptions));
    this.relTypeOptions.forEach(element => {
        let item = options.filter(el => el.id == element['pid']);
        element['pid'] = item.length>0 ? item[0].value : '0';
        element['parentId'] = element['pid'];
        element['id'] = element['value'];
    });
    this.upOrAdd = this.param.upOrAdd;
    // 关系新增
    if (this.upOrAdd === 'add') {
      this.relationDatas.sourceUUID = this.param.sourceUUID;
      this.getInstanceIdDetails();
    }
    // 关系编辑
    else{
      let params = {
          startNodeId: this.param.sourceUUID,
          uuid: this.param.properties.uuid,
      }
      this.getRelationshipById(params);
    }
  }

  // 根据关系ID查询关系详细数据
  getRelationshipById(params) {
    this.kmsService.getRelationshipById(params).subscribe(
        result => {
            if (result.code == 200) {
                let datas = result.data;
                this.relationDatas = datas;
                let properties = this.relationDatas.properties ? this.relationDatas.properties : null;
                this.relationDatas.properties.pageNum = properties.pageNum && properties.pageNum > 0 ? properties.pageNum : null;
                this.relationDatas.properties.relPageNum = properties.relPageNum && properties.relPageNum > 0 ? properties.relPageNum : null;
                this.getRelationTreeData();
            } else {
                this.message.waring("数据错误，请稍后再试！");
            }
        }
    )
  }

  // 根据实体id查询实体详细信息
  getInstanceIdDetails() {
    this.kmsService
      .getInstanceById(this.relationDatas.sourceUUID)
      .subscribe((result) => {
        if (result.code == 200) {
          let datas = result.data;
          this.relationDatas.sourceProperties.nodeName = datas.instanceName;
          this.relationDatas.sourceProperties.conceptId = datas.conceptId;
          this.relationDatas.sourceProperties.conceptName = datas.conceptName;
        } else {
          this.message.waring("数据错误，请稍后再试！");
        }
      });
  }

  // 查询概念数据
  getConceptTree() {
    this.kmsService.getConceptTreeData({}).subscribe((data) => {
      if (data.code == 200) {
        if (!data.data) {
          this.ontologyTreeDatas = [];
        }
        this.ontologyTreeDatas = data.data;
        this.readonlySelfIds = ["0"];
        this.ontologyTreeDatas.forEach((item) => {
          if (!item.parentId) {
            item.parentId = "0";
            item.pid = item.parentId;
          } else {
            item.pid = item.parentId;
          }
          // 根据是否有子级判断是否为概念节点，概念节点不可选择
          if (
            this.ontologyTreeDatas.filter((item1) => item1.pid == item.id)
              .length > 0
          ) {
            this.readonlySelfIds.push(item.id);
          }
        });
        const rootNode = {
          id: "0",
          pid: null,
          text: "概念配置",
        };
        this.ontologyTreeDatas.push(rootNode);
      }
    });
  }

  // 查询关系树数据
  getRelationTreeData() {
    let params = {
      sourceConceptId: this.relationDatas.sourceProperties.conceptId,
      targetConceptId: this.relationDatas.targetProperties.conceptId,
    };
    // 查询左侧关系树数据
    this.kmsService.getRelationTreeListPrefix(params).subscribe((data) => {
      if (data.code == "200") {
        if (!data.data) {
          this.message.danger("当前关系名称不存在！");
          return;
        }
        data.data.forEach(element => {
          element['text'] = element['reverseName'] ? element['name']+"（"+element['reverseName']+"）" : element['name'];
        });
        this.relationTreeDataCopy = data.data;
        this.readonlyRetionSelfIds = ["0"];
        this.relationTreeDataCopy.forEach((item) => {
          if (!item.pid) {
            item.pid = "0";
          }
          // 根据是否有父级判断是否为概念组节点，概念组节点不可选择
          if (
            this.relationTreeDataCopy.filter((item1) => item1.id == item.pid)
              .length == 0
          ) {
            this.readonlyRetionSelfIds.push(item.id);
          }
        });
        this.relationTreeData = JSON.parse(JSON.stringify(this.relationTreeDataCopy));
      }
    });
  }

  // 概念下拉切换选中方法
  // type = 0为起始实体概念切换，type = 1为指向实体概念切换
  handleConceptChange(event, type) {
    if (type == 1) {
      // 获取指向概念
      this.relationDatas.targetProperties.conceptId = event.id;
      this.relationDatas.targetProperties.conceptName = event.text;
      // 清空指向实体
      this.relationDatas.targetProperties.nodeName = '';
      this.relationDatas.targetUUID = '';
      // 当前为批量创建实体关系操作时
      if(this.upOrAdd == 'add' && this.state == 'batch'){
        // 展示右侧实体表格
        this.isShowRightInstance = true;
        this.getInstanceListDatas();
        // 清空选中的实体数据
        this.selectInstance = [];
        this.rightInstanceDatas = [];
      }
    } else {
      // 获取起始概念
      this.relationDatas.sourceProperties.conceptId = event.id;
      this.relationDatas.sourceProperties.conceptName = event.text;
      // 清空起始实体
      this.relationDatas.sourceProperties.nodeName = '';
      this.relationDatas.sourceUUID = '';
    }
    // 清空关系
    this.relationTreeData = [];
    this.relationTreeDataCopy = [];
    this.relType = '';
    this.relationDatas.properties.relationshipId = '';
    this.relationDatas.properties.relationshipName = '';
    this.relationDatas.properties.reverseRelationName = '';
    this.relationDatas.properties.relationAlias = '';
    this.relationDatas.properties.reverseRelationAlias = '';
    this.relationDatas.properties.parentId = '';
    // 如果起始实体概念和指向实体概念都存在
    if (this.relationDatas.sourceProperties.conceptName && this.relationDatas.targetProperties.conceptName) {
      this.getRelationTreeData();
    }
  }

  // 概念清空方法
  // type = 0为起始实体概念切换，type = 1为指向实体概念切换
  handleConceptClear(event, type) {
    if (type == 1) {
      // 清空指向概念
      this.relationDatas.targetProperties.conceptId = '';
      this.relationDatas.targetProperties.conceptName = '';
      // 清空指向实体
      this.relationDatas.targetProperties.nodeName = '';
      this.relationDatas.targetUUID = '';
      // 当前为批量创建实体关系操作时
      if(this.upOrAdd == 'add' && this.state == 'batch'){
        // 隐藏右侧实体表格
        this.isShowRightInstance = false;
        // 清空选中的实体数据
        this.selectInstance = [];
        this.rightInstanceDatas = [];
      }
    } else {
      // 清空起始概念
      this.relationDatas.sourceProperties.conceptId = '';
      this.relationDatas.sourceProperties.conceptName = '';
      // 清空起始实体
      this.relationDatas.sourceProperties.nodeName = '';
      this.relationDatas.sourceUUID = '';
    }
    // 清空关系
    this.relationTreeData = [];
    this.relationTreeDataCopy = [];
    this.relType = '';
    this.relationDatas.properties.relationshipId = '';
    this.relationDatas.properties.relationshipName = '';
    this.relationDatas.properties.reverseRelationName = '';
    this.relationDatas.properties.relationAlias = '';
    this.relationDatas.properties.reverseRelationAlias = '';
    this.relationDatas.properties.parentId = '';
  }

  // 选择关系分类
  relChange(event){
    // 当前选择的两个概念间未配置过关系时无需进行筛选操作
    if(this.relationTreeDataCopy.length<=1){
      return;
    }
    // 根据当前关系分类id找到所有的子级
    let arr = [event.id];
    let childs1 = this.relTypeOptions.filter(el => el.parentId == event.id);
    if(childs1.length>0){
      arr = arr.concat(childs1.map(el => el.id));
      childs1.forEach(el => {
        let childs2 = this.relTypeOptions.filter(el1 => el1.parentId == el.id);
        if(childs2.length>0){
          arr = arr.concat(childs2.map(el2 => el2.id));
        }
      })
    }
    let selected = [];
    this.relationTreeDataCopy.forEach(el => {
      // 概念组节点不参与筛选
      if(this.readonlyRetionSelfIds.indexOf(el.id)>-1){
        selected.push(el);
      }else{
        // 关系名称节点通过关系分类进行筛选
        if(el.relType && arr.indexOf(el.relType)>-1){
          selected.push(el);
        }
      }
    })
    this.relationTreeData = JSON.parse(JSON.stringify(selected));
  }

  // 清空关系分类
  relClear(event){
    this.relationTreeData = JSON.parse(JSON.stringify(this.relationTreeDataCopy));
  }

  // 关系下拉切换选中方法
  handleRelationChange(event) {
    // 赋值当前选中的关系名称
    let items = this.relationTreeData.filter(el => el.id == event.id);
    this.relationDatas.properties.relationshipName = items[0].name;
    this.relationDatas.properties.reverseRelationName = items[0].reverseName;
    this.relationDatas.properties.relationAlias = items[0].relationAlias ? items[0].relationAlias : '';
    this.relationDatas.properties.reverseRelationAlias = items[0].reverseRelationAlias ? items[0].reverseRelationAlias : '';
  }

  // 起始实体或指向实体发生变化
  handleInstanceChange(event,type){
    if (type == 1) {
      this.relationDatas.targetProperties.nodeName = event.text;
    } else {
      this.relationDatas.sourceProperties.nodeName = event.text;
    }
  }

  // 交换起始实体与指向实体
  changeDirection(){
    // 单条创建
    if(this.state == 'single'){
      // 交换起始、指向实体
      let sourceUUID = this.relationDatas.sourceUUID;
      this.relationDatas.sourceUUID = this.relationDatas.targetUUID;
      this.relationDatas.targetUUID = sourceUUID;
    }
    // 批量创建
    else{
      this.relationDatas.sourceUUID = '';
      this.relationDatas.targetUUID = '';
      this.rightInstanceDatas = [];
    }
    if(this.relationDatas.sourceProperties.conceptId != this.relationDatas.targetProperties.conceptId){
      // 交换起始、指向概念
      let startConcept = JSON.parse(JSON.stringify(this.relationDatas.sourceProperties));
      this.relationDatas.sourceProperties = JSON.parse(JSON.stringify(this.relationDatas.targetProperties));
      this.relationDatas.targetProperties = startConcept;
      // 若指向概念不存在
      if(!this.relationDatas.targetProperties.conceptId){
        // 隐藏右侧实体表格
        this.isShowRightInstance = false;
        // 清空选中的实体数据
        this.selectInstance = [];
      }else{
        // 展示右侧实体表格
        this.isShowRightInstance = true;
        this.getInstanceListDatas();
        // 清空选中的实体数据
        this.selectInstance = [];
      }
      // 清空关系
      this.relationTreeData = [];
      this.relationTreeDataCopy = [];
      this.relType = '';
      this.relationDatas.properties.relationshipId = '';
      this.relationDatas.properties.relationshipName = '';
      this.relationDatas.properties.reverseRelationName = '';
      this.relationDatas.properties.relationAlias = '';
      this.relationDatas.properties.reverseRelationAlias = '';
      this.relationDatas.properties.parentId = '';
      // 如果起始实体概念和指向实体概念都存在
      if (this.relationDatas.sourceProperties.conceptName && this.relationDatas.targetProperties.conceptName) {
        this.getRelationTreeData();
      }
    }
  }

  // 获取时间中的年月日
  getYearOrMonthOrDay(key, dateStr) {
    let data;
    if (!dateStr) {
      data = {
        year: "",
        month: "",
        day: "",
      };
    } else {
      const dateArr = dateStr.split("/");
      const len = dateArr.length;
      data = {
        year: len > 0 ? dateArr[0] : "",
        month: len > 1 ? dateArr[1] : "",
        day: len > 2 ? dateArr[2] : "",
      };
      if (dateArr[0] && dateArr[1]) {
        this.dayArr = this.instanceModuleService.getDayDatas(
          dateArr[0],
          dateArr[1]
        );
      }
    }
    return data[key];
  }

  // 获取年号
  getTime(name) {
    let parent = $('input[name="' + name + '"]').parent();
    const value = parent.find(".year").val();
    if (value) {
      if (value > 1949) {
        if (name == "startDate") {
          // 发生时间
          this.relationDatas.properties.startDateNote = `${value}年`;
        } else {
          // 结束时间
          this.relationDatas.properties.endDateNote = `${value}年`;
        }
      } else {
        this.kmsService.getInstanceTimeNoteByYear(value).subscribe((data) => {
          if (data.code == "200") {
            const res = data.data;
            if (name == "startDate") {
              // 发生时间
              this.relationDatas.properties.startDateNote = res;
            } else {
              // 结束时间
              this.relationDatas.properties.endDateNote = res;
            }
          } else {
            this.message.waring(data.msg);
          }
        });
      }
    }
  }

  // 将年月日拼接成字符串
  getDateStr(keyName) {
    let parent = $('input[name="' + keyName + '"]').parent();
    const yearValue = parent.find(".year").val();
    const monthValue = parent.find(".month").val();
    const dayValue = parent.find(".day").val();

    let res = this.instanceModuleService.validateTime(
      yearValue,
      monthValue,
      dayValue
    );
    if (keyName == "startDate") {
      // 发生时间
      this.relationDatas.properties.startDate = res.timeStr;
    } else {
      // 结束时间
      this.relationDatas.properties.endDate = res.timeStr;
    }

    let item = {};
    item[keyName] = res.timeStr;
    if (!res.isValid) {
      if (this.errorList.indexOf(keyName) < 0) {
        this.errorList.push(keyName);
        parent.parent().find(".tip-error").removeClass("hidden");
        parent.find(".year,.month,.day").addClass("input-error");
      }
    } else {
      const index = this.errorList.indexOf(keyName);
      if (index >= 0) {
        this.errorList.splice(index, 1);
        parent.parent().find(".tip-error").addClass("hidden");
        parent.find(".year,.month,.day").removeClass("input-error");
      }
    }
  }

  // 新增、编辑概念关系
  onSubmit() {
    // 新增、编辑关系（单条操作)
    if(this.state == 'single'){
      this.clickEnable = false;
      let params = {
        "relationship": this.relationDatas.properties,
        "sourceUUID": this.relationDatas.sourceUUID,
        "targetName": this.relationDatas.targetProperties.nodeName,
        "targetUUID": this.relationDatas.targetUUID
      }
      this.kmsService.saveRelationshipUpdate(params).subscribe((data) => {
        this.clickEnable = true;
        if (data.code == "200") {
          this.message.success("操作成功！");
          this.modal.toggle();
          this.callback.emit(true);
        } else {
          this.message.waring(data.msg);
        }
      });
    }else{
      // 批量新增关系
      let params = [];
      this.rightInstanceDatas.forEach(el => {
        let item = {
          "relationship": this.relationDatas.properties,
          "sourceUUID": this.relationDatas.sourceUUID,
          "targetName": el.nodeName,
          "targetUUID": el.nodeId
        }
        params.push(item);
      })  
      this.clickEnable = false;
      this.kmsService.saveRelationshipBatchUpdate(params).subscribe((data) => {
        this.clickEnable = true;
        if (data.code == "200") {
          this.message.success("操作成功！");
          this.modal.toggle();
          this.callback.emit(true);
        } else {
          this.message.waring(data.msg);
        }
      });
    }
  }

  // 根据指向实体概念查询实体表格数据
  getInstanceListDatas() {
    this.isLoading = true;
    let params = {
      current: this.pageBase.current,
      size: this.pageBase.size,
      conceptId: this.relationDatas.targetProperties.conceptId,
      instanceName: this.instanceName,
    };
    this.kmsService.getInstanceQueryList(params).subscribe((result) => {
      if (result.code == 200) {
        this.isLoading = false;
        this.pageBase = result.data;
        this.instanceDatas = result.data.records;
      } else {
        this.instanceDatas = [];
        this.message.waring(result.msg);
      }
    });
  }

  // 实体表格监听enter键查询
  handeleEnterSearch(event) {
    if (event.keyCode == "13") {
      this.pageBase.current = 1;
      this.pageBase.size = 10;
      this.getInstanceListDatas();
    }
  }

  // 实体表格查询按钮
  handleSelectClick() {
    this.pageBase.current = 1;
    this.pageBase.size = 10;
    this.getInstanceListDatas();
  }

  // 实体表格选中数据
  handleSelectData(event) {
    this.selectInstance = event;
  }

  // 实体表格查看实体详情
  handleViewClick(event, instanceId) {
    //禁止冒泡
    event.stopPropagation();
    let param = { instanceId: instanceId };
    this.create.createModal(InstanceInfoViewComponent, param);
  }

  // 实体表格分页点击方法
  handlePageClick(event) {
    this.pageBase = event;
    this.getInstanceListDatas();
  }

  // 实体表格确定方法
  handleConfirmClick() {
    console.log(this.selectInstance);
    if(this.selectInstance.length == 0){
      this.message.info('请选择指向实体！');
      return;
    }
    if(this.rightInstanceDatas.length == 0){
      this.selectInstance.forEach(el => {
        let item = {
          nodeId: el.instanceId,
          nodeName: el.instanceName
        }
        this.rightInstanceDatas.push(item);
      })
    }else{
      this.selectInstance.forEach(el => {
        let item = {
          nodeId: el.instanceId,
          nodeName: el.instanceName
        }
        if(this.rightInstanceDatas.filter(el1 => el1.nodeId == item.nodeId).length == 0){
          this.rightInstanceDatas.push(item);
        }
      })
    }
  }

  // 指向实体删除方法
  handleDelInstanceClick(i) {
    this.rightInstanceDatas.splice(i, 1);
  }

  // 监听右侧实体表格区域滚动条
  handeleScroll(event) {
    if (event.srcElement.scrollTop > 60) {
      $(".coustom-table .main-searchbox").addClass("fix-top");
    } else {
      $(".coustom-table .main-searchbox").removeClass("fix-top");
    }
  }

  // 切换单条创建、批量创建
  tabClick(state){
    this.state = state;
    if(state == 'batch' && this.relationDatas.targetProperties.conceptId){
      // 展示右侧实体表格
      this.isShowRightInstance = true;
      this.getInstanceListDatas();
    }
  }

  // 选中素材内容，填充到输入框中
  handleFillClick() {
    let data = this.jwt.getToken('materialTextSelect') ? JSON.parse(this.jwt.getToken('materialTextSelect')) : null;
    if(data){
      this.relationDatas.properties["materialId"] = data.materialId;
      this.relationDatas.properties["description"] = data.sourceText;
      this.relationDatas.properties["sourceMaterial"] = data.sourceMaterial;
      this.relationDatas.properties["pageNum"] = data.pageNum;
      this.relationDatas.properties["relPageNum"] = data.relPageNum;
      this.relationDatas.properties["dataSource"] = data.datasource;
    }
    this.jwt.setToKen('materialTextSelect','');
  }

  toggleMaterial(state){
    this.showMaterials = state;
  }

  setMaterial(item){
    this.relationDatas.properties.materialId = item.materialId;
    this.relationDatas.properties.sourceMaterial = item.materialTitle;
    this.showMaterials = false;
  }

  //enter键触发搜索
  enterSearch(event) {
    if (event.keyCode == '13') {
      this.searchMaterial();
    }
  }

  searchMaterial(){
    let keyword = $.trim(this.keyword);
    if(!keyword){
      this.message.danger('请输入素材名称！');
      return;
    }
    let params = {
      current: 1,
      size: 30,
      materialTitle: keyword,
      materialCategory: this.materialCategory == 'FILE_TYPE_ALL' ? '' : this.materialCategory
    }
    this.kmsService.queryMaterialList(params).subscribe(
      data => {
        if (data.code == '200') {
          this.materialList = data.data.records ? data.data.records : [];
        } else {
          console.log(data.msg);
        }
      }
    );
  }

  clear(){
    this.relationDatas.properties.materialId = '';
    this.relationDatas.properties.sourceMaterial = '';
  }

}
